export * from "./getEachWayTitle";